<template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-6
        .panel.panel-default
          .panel-heading.panel-title Client
          .panel-body(v-if="client")
            .row
              label.col-sm-2.control-label Version
              .col-sm-10
                span {{client.version}}
            .row
              label.col-sm-2.control-label Revision
              .col-sm-10
                span {{client.revision}}
            .row
              label.col-sm-2.control-label Build time
              .col-sm-10
                span {{client.time | date}}
      .col-md-6
        .panel.panel-default
          .panel-heading.panel-title Server
          .panel-body(v-if="server")
            .row
              label.col-sm-2.control-label Version
              .col-sm-10
                span {{server.version}}
            .row
              label.col-sm-2.control-label Revision
              .col-sm-10
                span {{server.revision}}
            .row
              label.col-sm-2.control-label Build time
              .col-sm-10
                span {{server.time | date}}

</template>

<script>
import { dateFilter } from '@/filters/filters'
import Version from '@/service/Version'

export default {
  data: () => ({
    server: null,
    client: null
  }),
  created() {
    Version.server()
      .then((resp) => {
        this.server = {}
        this.server.version = resp.data.build.version
        this.server.revision = resp.data.git.commit.id
        this.server.time = resp.data.git.commit.time
      })
    Version.client()
      .then((resp) => {
        this.client = {}
        this.client.version = resp.data.version
        this.client.revision = resp.data.revision.substring(0, 7)
        this.client.time = new Date(resp.data.buildDate)
      })
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/About.vue